export enum ChartPeriodEnum {
  beginning = "Since beginning",
  lastMonth = "Last 30 days",
  lastYear = "Last 12 months"
}
